import { useEffect } from 'react'
import styles from './index.module.scss'

const LoadingCom = (props) => {

    return (
        <div className={styles.LoadingCom}>
            <img src="https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/images_v3/loadingBlue.gif" alt="" />
            <p>云端处理中，马上好~</p>
        </div>
    )
}

export default LoadingCom